// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-block {
    height: 100vh;
    width: 100vw;
    background: rgb(0, 0, 0, 0.7);
    z-index: 10000;
    position: fixed;
    top: 0px;
    left: 0px;
    display: flex;
}

.loading-block img {
    width: 300px;
    margin: auto;
    animation: loading 2s linear infinite;
}

@keyframes loading {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/LoadingBlock.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".loading-block {\n    height: 100vh;\n    width: 100vw;\n    background: rgb(0, 0, 0, 0.7);\n    z-index: 10000;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    display: flex;\n}\n\n.loading-block img {\n    width: 300px;\n    margin: auto;\n    animation: loading 2s linear infinite;\n}\n\n@keyframes loading {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
